import styled from "styled-components"
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { FirstSlideItems } from "../Assets/data.js";
import { useState } from "react";
import { ExtraSmall,Small } from "../Responsive.js";

const Container=styled.div`
display: flex;
height: 100vh;
position: relative;
margin: 7vh auto;
width: 90%;
overflow: hidden;
${ExtraSmall({height:'80vh'})}
`
const Arrow=styled.div`
background-color: #fff7f7;
border-radius: 50%;
cursor: pointer;
display: flex;
align-items: center;
justify-content: center;
height: 50px;
padding-left:${props=>props.direction==='left'&&'10px'};
padding-right:${props=>props.direction==='right'&&'-2px'};
position: absolute;
top: 0;
left: ${props=>props.direction==='left' && '10px'};
right: ${props=>props.direction==='right' && '10px'};
bottom: 0;
margin: auto; 
width:50px;
opacity: 0.5;
z-index: 1;
&:hover{
    // background-color:#3e3e3e;
    border:0.5px solid black;
}
`
const Wrapper=styled.div`
display: flex;
height: 100%;
transform: translateX(${props=>props.slideIndex*-100}vw);
transition: all 1.5s ease;
`

const Slide=styled.div`
background-color: #${props=>props.bg};
height: 100vh;
width: 90vw;
display: flex;
align-items: center;
${ExtraSmall({flexDirection:"column",width:'100vw'})};
${Small({flexDirection:'column',width:'100vw'})}
`
const ImageContainer=styled.div`
height: 100%;
flex:1;
`
const InfoContainer=styled.div`
flex: 1;
padding: 50px;
${ExtraSmall({marginTop:'-99px'})};
${Small({marginTop:'-90px;'})}
`
const Image=styled.img`
height: 80%;
object-fit:cover;
width: 100%;
${ExtraSmall({width:'100%',height:"80%"})};
${Small({width:'100%',height:'89%'})}
`

const Title=styled.h1`
font-size: 45px;
${ExtraSmall({fontSize:"30px"})}'
${Small({fontSize:'30px'})}
`
const Desc =styled.p`
 margin: 50px 0;
 font-size: 16px;
 font-weight: 300;
 letter-spacing: 2px;
`


const Slider=()=>{

    const[slideIndex,setSlideIndex]=useState(0)
    const FirstSlidesLength = FirstSlideItems.length;
  
    const handleClick=(direction)=>{

        if(direction==='left'){                      
            setSlideIndex(slideIndex>0?slideIndex-1:FirstSlidesLength-1)
        }else{
            setSlideIndex(slideIndex<FirstSlidesLength-1?slideIndex+1:0)
        }
    
    }

    return(
        <Container>

           {/*Left Arrow  */}
           <Arrow direction="left" onClick={()=>handleClick("left")}>
              {/* < ArrowLeftOutlinedIcon/> */}
              <ArrowBackIosIcon/>
           </Arrow>
             
             {/* Slide Wrapper */}
           <Wrapper slideIndex={slideIndex}>

           {FirstSlideItems.map((item)=>{
                return(
                    <Slide bg={item.bg} key={item.id}>
                    <ImageContainer>
                        <Image src={item.img}/>
                    </ImageContainer>
                    <InfoContainer>
                        <Title>{item.title}</Title>
                        <Desc>{item.desc}</Desc>
                    </InfoContainer>
                  </Slide>
                )
              })}
    
           </Wrapper>

           {/* Right Arrow */}
           <Arrow direction="right" onClick={()=>handleClick('right')}>
             {/* <ArrowRightOutlinedIcon /> */}
             <ArrowForwardIosIcon/>
           </Arrow>

        </Container>
    )
}
export default Slider